var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'usertype-edit',
  created () {
    this.search()
    this.getQuestions()
  },
  data () {
    return {
      canValidate: true,
      contentCount: 0,
      getQuestionEnd: false
    }
  },
  computed: {
    usertype () {
      return this.$store.getters.edit_user_type
    },
    businesstype () {
      return this.$store.getters.user_type_business_type
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    validation: function() {
      var v = {
        user_type_name: !!this.usertype.data.attributes['user-type-name'],
        default_user_authority: [1, 2, 3, 4, 5].indexOf(this.usertype.data.attributes['default-user-authority']) >= 0,
        user_type_priority: !!this.usertype.data.attributes['user-type-priority'],
        employee_flg: [0,1].indexOf(this.usertype.data.attributes['employee-flg']) >= 0,
        business_type_content: !!this.businesstype.data.attributes['business-type-content'],

        not_input: !!this.usertype.data.attributes['user-type-name'] &&
                   [1, 2, 3, 4, 5].indexOf(this.usertype.data.attributes['default-user-authority']) >= 0 &&
                   !!this.usertype.data.attributes['user-type-priority'] &&
                   [0,1].indexOf(this.usertype.data.attributes['employee-flg']) >= 0 &&
                   !!this.businesstype.data.attributes['business-type-content'],
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }

  },
  components: {
    AppHeader
  },
  methods: {
    async getQuestions () {
      let data = {}
      let res = await this.$store.dispatch('GET_QUESTION_ALL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.questions = res.questions
      this.getQuestionEnd = true
    },
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        var data = {
          user_type_name: this.usertype.data.attributes['user-type-name'],
          default_user_authority: this.usertype.data.attributes['default-user-authority'],
          user_type_priority: this.usertype.data.attributes['user-type-priority'],
          employee_flg: this.usertype.data.attributes['employee-flg'],
          business_type_content: this.businesstype.data.attributes['business-type-content'],
          question_id: this.usertype.data.attributes['question-id']
        }
        this.$store.dispatch('USER_TYPE_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
      } else {
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/user_types', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      data.callback = function () {
        self.contentCounter()
      }
      this.$store.dispatch('USER_TYPE_EDIT',  {id: this.$route.params.id, data: data})
    },
    half: function () {
      this.usertype.data.attributes['user-type-name'] = utils.emHalf(this.usertype.data.attributes['user-type-name'])
    },
    halfBusiness: function () {
      this.businesstype.data.attributes['business-type-content'] = utils.emHalf(this.businesstype.data.attributes['business-type-content'])
    },
    onSaved: function (result) {
      this.$router.push({ path: '/user_types/'})
    },
    contentCounter: function() {
      this.halfBusiness()
      this.contentCount = this.businesstype.data.attributes['business-type-content'].length
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/usertype-edit.js